// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2XeeR","right":"styles_right__3-65z"};